import {applyMiddleware, compose, createStore} from 'redux'
import { createLogger } from 'redux-logger'
import { rootReducer, rootEpic } from './redux'
import { createEpicMiddleware } from 'redux-observable';

let epicMiddleware = createEpicMiddleware();

let loggerMiddleware = createLogger({
    collapsed: true,
    diff: true, // Show state diff instead of full state
    actionTransformer: (action) => {
      if (action.password) {
        action = {
            ...action,
            password: '*** Intentionally hidden, see configureStore.js ***'
        }
      }
      if (action.retypePassword) {
            action = {
                ...action,
                retypePassword: '*** Intentionally hidden, see configureStore.js ***'
            }
        }
      if (action.newPassword) {
            action = {
                ...action,
                newPassword: '*** Intentionally hidden, see configureStore.js ***'
            }
        }
        if (action.retypeNewPassword) {
            action = {
                ...action,
                retypeNewPassword: '*** Intentionally hidden, see configureStore.js ***'
            }
        }
        if (action.currentPassword) {
            action = {
                ...action,
                currentPassword: '*** Intentionally hidden, see configureStore.js ***'
            }
        }
        if (action.newPasswordRetype) {
            action = {
                ...action,
                newPasswordRetype: '*** Intentionally hidden, see configureStore.js ***'
            }
        }
        if (action.fieldName && (action.fieldName === "newPassword" || action.fieldName === "newPasswordRetype" || action.fieldName === "currentPassword")) {
            action = {
                ...action,
                fieldValue: '*** Intentionally hidden, see configureStore.js ***'
            }
        }
      return action;
    }
})

let configureStore = () => {
  let store = createStore(
      rootReducer,
      {},
      compose(
        applyMiddleware(
            epicMiddleware,
            loggerMiddleware
        )
      )
  );
  epicMiddleware.run(rootEpic);
  return store
}


export default configureStore